const allEmailTemplateDetailsReducer =(state=null, action)=>{
    switch(action.type){
      case "GET_ALL_EMAIL_TEMPLATE_DETAILS":
          return state;
      case "SET_ALL_EMAIL_TEMPLATE_DETAILS" :
          return action.info;
      case "NULL_ALL_EMAIL_TEMPLATE_DETAILS" :
          return action.info;
      default:
          return state;
    }
  }
  export default allEmailTemplateDetailsReducer
